const propertiesListColumn = 
[
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "Label FR",
    dataIndex: "label_fr",
    key: "label_fr",
  },
  {
    title: "Code FR",
    dataIndex: "code_fr",
    key: "code_fr",
  },
  {
    title: "Label EN",
    dataIndex: "label_en",
    key: "label_en",
  },
  {
    title: "Code EN",
    dataIndex: "code_en",
    key: "code_en",
  },
]

export default propertiesListColumn;


// WEBPACK FOOTER //
// src/containers/admin/properties/PropertiesList.utils.js